/** Label shown when a fixture side has no confirmed team yet. */
export const TEAM_TBD_LABEL = 'TBD';

/**
 * @param {string|null|undefined} name
 * @returns {boolean}
 */
export function isTeamDisplayPending(name) {
  if (name == null) return true;
  const s = String(name).trim();
  return !s || /^tbd$/i.test(s);
}

/**
 * @param {string|null|undefined} name
 * @returns {string}
 */
export function formatTeamDisplayName(name) {
  return isTeamDisplayPending(name) ? TEAM_TBD_LABEL : String(name).trim();
}

/**
 * @param {string|null|undefined} homeTeam
 * @param {string|null|undefined} awayTeam
 * @returns {string}
 */
export function formatMatchupLabel(homeTeam, awayTeam) {
  return `${formatTeamDisplayName(homeTeam)} vs ${formatTeamDisplayName(awayTeam)}`;
}
